// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Plugins
import { convertTemperature } from '../../../../../../../../plugins/general';

// Store
import {
  getMeasurementUnit,
} from '../../../../../../../../store/measurement.store';

// Types
import {
  MeasurementType,
  TemperatureType,
} from '../../../../../../../../types/global';

// Components
import { Col } from '../../../../../../../../layout/elements/Col';
import { EquipmentSensorListItem } from '../../../../../../../../components/EquipmentSensorList';
import { Row } from '../../../../../../../../layout/elements/Row';

// Modules
import { ListModule } from '../../../ListModule';

// Component
import { Container, ListContainer } from './Lubrication.style';
import { LubricationProps } from './Lubrication.types';

function Lubrication({
  className,
  testId,
  unitData,
}: LubricationProps): JSX.Element {
  // Dependencies
  const { t } = useTranslation();

  const temperatureUnit: TemperatureType = getMeasurementUnit(MeasurementType.temperature);

  const returnTempItems: EquipmentSensorListItem[] = [
    {
      sensor: `${t('view.crusher.vsi.maintenance.setpoint.lubrication.returnTemp.lowAlarm')}`,
      setpoint: convertTemperature(
        unitData?.spLubeReturnTempLowAlarm,
        temperatureUnit,
        0,
        true,
      ).formattedValue,
    },
    {
      sensor: `${t(
        'view.crusher.vsi.maintenance.setpoint.lubrication.returnTemp.lowWarning',
      )}`,
      setpoint: convertTemperature(
        unitData?.spLubeReturnTempLowWarning,
        temperatureUnit,
        0,
        true,
      ).formattedValue,
    },
    {
      sensor: `${t(
        'view.crusher.vsi.maintenance.setpoint.lubrication.returnTemp.crusherStartPermissive',
      )}`,
      setpoint: convertTemperature(
        unitData?.spLubeReturnTempCrusherStartPermissive,
        temperatureUnit,
        0,
        true,
      ).formattedValue,
    },
  ];

  const tankTempItems: EquipmentSensorListItem[] = [
    {
      sensor: `${t(
        'view.crusher.vsi.maintenance.setpoint.lubrication.tankTemp.pumpRunPermissive',
      )}`,
      setpoint: convertTemperature(
        unitData?.spLubeTankTempLowAlarm,
        temperatureUnit,
        0,
        true,
      ).formattedValue,
    },
    {
      sensor: `${t(
        'view.crusher.vsi.maintenance.setpoint.lubrication.tankTemp.pumpStartPermissive',
      )}`,
      setpoint: convertTemperature(
        unitData?.spLubeTankTempLowWarning,
        temperatureUnit,
        0,
        true,
      ).formattedValue,
    },
    {
      sensor: `${t(
        'view.crusher.vsi.maintenance.setpoint.lubrication.tankTemp.highWarning',
      )}`,
      setpoint: convertTemperature(
        unitData?.spLubeTankTempHighWarning,
        temperatureUnit,
        0,
        true,
      ).formattedValue,
    },
    {
      sensor: `${t(
        'view.crusher.vsi.maintenance.setpoint.lubrication.tankTemp.highAlarm',
      )}`,
      setpoint: convertTemperature(
        unitData?.spLubeTankTempHighAlarm,
        temperatureUnit,
        0,
        true,
      ).formattedValue,
    },
  ];

  const lubeCoolerItems: EquipmentSensorListItem[] = [
    {
      sensor: `${t(
        'view.crusher.vsi.maintenance.setpoint.lubrication.lubeCooler.coolerStartPermissive',
      )}`,
      setpoint: convertTemperature(
        unitData?.spLubeCoolerStartTemp,
        temperatureUnit,
        0,
        true,
      ).formattedValue,
    },
    {
      sensor: `${t(
        'view.crusher.vsi.maintenance.setpoint.lubrication.lubeCooler.coolerStopPermissive',
      )}`,
      setpoint: convertTemperature(
        unitData?.spLubeCoolerStopTemp,
        temperatureUnit,
        0,
        true,
      ).formattedValue,
    },
  ];

  return (
    <Container className={className} data-testid={testId}>
      <Row>
        <Col cols={8}>
          <ListContainer>
            <ListModule
              title={`${t('view.crusher.vsi.maintenance.setpoint.lubrication.returnTemp.title')}`}
              items={returnTempItems}
            />
          </ListContainer>
        </Col>
        <Col cols={8}>
          <ListContainer>
            <ListModule
              title={`${t('view.crusher.vsi.maintenance.setpoint.lubrication.tankTemp.title')}`}
              items={tankTempItems}
            />
          </ListContainer>
        </Col>
        <Col cols={8}>
          <ListContainer>
            <ListModule
              title={`${t('view.crusher.vsi.maintenance.setpoint.lubrication.lubeCooler.title')}`}
              items={lubeCoolerItems}
            />
          </ListContainer>
        </Col>
      </Row>
    </Container>
  );
}

export { Lubrication };
